<!-- Error page-->
<div class="misc-wrapper">
  <!-- Brand logo-->
  <a
    class="brand-logo d-none d-lg-flex"
    href="/">
    <img
      [src]="logoService.logoPath"
      alt="brand-logo"
      height="75px" />
  </a>
  <!-- /Brand logo-->
  <div class="misc-inner p-2 p-sm-3">
    <div class="w-100 text-center">
      <h2 class="mb-1">System wird aktualisiert</h2>
      <p class="mb-2">
        Der Server ist momentan leider nicht erreichbar, da gerade eine neue Version geladen wird. Bitte versuchen Sie
        es in ein paar Minuten erneut.
      </p>
      <a
        (click)="returnToRedirectUrl()"
        class="btn btn-primary mb-2 btn-sm-block"
        href="javascript:void(0)"
        rippleEffect
        >Neu Laden</a
      >
    </div>
  </div>
</div>
<!-- / Error page-->
